'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal',
    function ($modal) {

        return {
            select: select,
            create: create,
            edit: edit,
            selectSupTool: selectSupTool,
            remove: remove
        };

        // region Function

        function select(project, filters, def) {
        }

        function create(support, edit, project) {
            return $modal.open({
                template: require('../view/project-support-modal-create.html'),
                controller: 'ProjectSupportModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    support: function () {
                        return {};
                    },
                    edit: function () {
                        return edit;
                    },
                    project: function() {
                        return project;
                    }
                }
            });
        }

        function selectSupTool(support, edit, project) {
            return $modal.open({
                template: require('../../../../support/view/supports-modal.html'),
                controller: 'SupportsController',
                size: 'w1200',
                backdrop: false,
                resolve: {
                    support: function () {
                        return {};
                    },
                    edit: function () {
                        return edit;
                    },
                    project: function() {
                        return project;
                    }
                }
            });
        }

        function edit(support, edit, project) {
            return $modal.open({
                template: require('../view/project-support-modal-create.html'),
                controller: 'ProjectSupportModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    support: function () {
                        return support;
                    },
                    edit: function () {
                        return edit;
                    },
                    project: function() {
                        return project;
                    }
                }
            });
        }

        function remove(project, callback) {
        }

        // endregion

    }];